import { registerCareTeam } from "../slices/careTeamSlice";
import { logErrorEvent } from "../services/logService";

/**
 * Fetch a CareTeam by ID
 * - Checks Redux store first
 * - Fetches from FHIR server if missing
 * - Registers into Redux
 */
export const fetchCareTeam = async (careTeamId, fhirClient, store, { forceFetch = false } = {}) => {
    console.log("fetching CareTeam by id");
    if (!careTeamId || !fhirClient) return null;

    // Check Redux cache
    const cached = store.getState().careTeams?.[careTeamId];
    if (cached && !forceFetch) {
        console.log(`🧠 CareTeam ${careTeamId} served from cache`);
        return cached;
    }

    try {
        console.log(`🌐 Fetching CareTeam/${careTeamId} from FHIR`);
        const fetched = await fhirClient.request(`CareTeam/${careTeamId}`);

        if (fetched?.resourceType !== "CareTeam") {
            console.warn("⚠️ Unexpected CareTeam response:", fetched);
            return null;
        }

        store.dispatch(registerCareTeam(fetched));
        return fetched;

    } catch (err) {
        console.error("❌ Failed to fetch CareTeam:", err);
        const status = err?.response?.status || err?.status || 500;
        logErrorEvent({
            errorType: "read",
            error: {
                message: err?.message || "CareTeam fetch failed",
                status,
                resourceId: `CareTeam/${careTeamId}`
            },
            description: `Failed to retrieve CareTeam/${careTeamId} from FHIR server`,
            store
        });
        return { error: status };
    }
};

/**
 * Fetch a CareTeam given a FHIR reference string
 * e.g. "CareTeam/123" or "CareTeam/123/_history/4"
 */
export const fetchCareTeamByReference = async (ref, fhirClient, store, options = {}) => {
    console.log("fetching CareTeam by Reference....................");

    if (!ref || typeof ref !== "string") {
        console.warn("⚠️ Invalid CareTeam reference (not a string):", ref);
        return null;
    }

    if (!ref.startsWith("CareTeam/")) {
        console.warn("⚠️ Reference is not a CareTeam:", ref);
        return null;
    }

    // Extract ID safely (handles versioned refs)
    const parts = ref.split("/");
    const careTeamId = parts[1];

    if (!careTeamId || careTeamId === "undefined" || careTeamId === "null") {
        console.warn("⚠️ Could not extract valid CareTeam ID from reference:", ref);
        return null;
    }

    return fetchCareTeam(careTeamId, fhirClient, store, options);
};
